import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { getSidebarStatus, getSize, setSidebarStatus, setLanguage, setSize } from '@/utils/cookies';
import { getLocale } from '@/lang';
import store from '@/store';
export var DeviceType;
(function (DeviceType) {
  DeviceType[DeviceType["Mobile"] = 0] = "Mobile";
  DeviceType[DeviceType["Desktop"] = 1] = "Desktop";
})(DeviceType || (DeviceType = {}));
var App = /*#__PURE__*/function (_VuexModule) {
  function App() {
    var _this;
    _classCallCheck(this, App);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, App, [].concat(args));
    _defineProperty(_this, "sidebar", {
      opened: getSidebarStatus() !== 'closed',
      withoutAnimation: false
    });
    _defineProperty(_this, "device", DeviceType.Desktop);
    _defineProperty(_this, "language", getLocale());
    _defineProperty(_this, "size", getSize() || 'medium');
    return _this;
  }
  _inherits(App, _VuexModule);
  return _createClass(App, [{
    key: "TOGGLE_SIDEBAR",
    value: function TOGGLE_SIDEBAR(withoutAnimation) {
      this.sidebar.opened = !this.sidebar.opened;
      this.sidebar.withoutAnimation = withoutAnimation;
      if (this.sidebar.opened) {
        setSidebarStatus('opened');
      } else {
        setSidebarStatus('closed');
      }
    }
  }, {
    key: "CLOSE_SIDEBAR",
    value: function CLOSE_SIDEBAR(withoutAnimation) {
      this.sidebar.opened = false;
      this.sidebar.withoutAnimation = withoutAnimation;
      setSidebarStatus('closed');
    }
  }, {
    key: "TOGGLE_DEVICE",
    value: function TOGGLE_DEVICE(device) {
      this.device = device;
    }
  }, {
    key: "SET_LANGUAGE",
    value: function SET_LANGUAGE(language) {
      this.language = language;
      setLanguage(this.language);
    }
  }, {
    key: "SET_SIZE",
    value: function SET_SIZE(size) {
      this.size = size;
      setSize(this.size);
    }
  }, {
    key: "ToggleSideBar",
    value: function ToggleSideBar(withoutAnimation) {
      this.TOGGLE_SIDEBAR(withoutAnimation);
    }
  }, {
    key: "CloseSideBar",
    value: function CloseSideBar(withoutAnimation) {
      this.CLOSE_SIDEBAR(withoutAnimation);
    }
  }, {
    key: "ToggleDevice",
    value: function ToggleDevice(device) {
      this.TOGGLE_DEVICE(device);
    }
  }, {
    key: "SetLanguage",
    value: function SetLanguage(language) {
      this.SET_LANGUAGE(language);
    }
  }, {
    key: "SetSize",
    value: function SetSize(size) {
      this.SET_SIZE(size);
    }
  }]);
}(VuexModule);
__decorate([Mutation], App.prototype, "TOGGLE_SIDEBAR", null);
__decorate([Mutation], App.prototype, "CLOSE_SIDEBAR", null);
__decorate([Mutation], App.prototype, "TOGGLE_DEVICE", null);
__decorate([Mutation], App.prototype, "SET_LANGUAGE", null);
__decorate([Mutation], App.prototype, "SET_SIZE", null);
__decorate([Action], App.prototype, "ToggleSideBar", null);
__decorate([Action], App.prototype, "CloseSideBar", null);
__decorate([Action], App.prototype, "ToggleDevice", null);
__decorate([Action], App.prototype, "SetLanguage", null);
__decorate([Action], App.prototype, "SetSize", null);
App = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'app'
})], App);
export var AppModule = getModule(App);